import { render, staticRenderFns } from "./PageSideMenu.vue?vue&type=template&id=468c8aab&scoped=true"
import script from "./PageSideMenu.vue?vue&type=script&lang=js"
export * from "./PageSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PageSideMenu.vue?vue&type=style&index=0&id=468c8aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c8aab",
  null
  
)

export default component.exports